import Vue from 'vue'
import Vuex from 'vuex'
import appModule from './modules/app'
import authModule from './modules/auth'
import userModule from './modules/user'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app:appModule,
        auth:authModule,
        user:userModule
    }
});

export default store;